import { useGetClientQuery } from "@/queries/useGetClientQuery";
import { useMemo } from "react";
export const useCertificates = () => {
  const { data: clientData, isLoading } = useGetClientQuery();

  const certificates = useMemo(() => {
    if (!clientData?.certificates) return [];

    return clientData.certificates.map((el) => el);
  }, [clientData?.certificates]);

  if (isLoading) {
    return { bonusesData: [], isLoading };
  }

  return { certificates };
};
